import { render, staticRenderFns } from "./navTabs.vue?vue&type=template&id=246b25ee&scoped=true&"
import script from "./navTabs.vue?vue&type=script&lang=js&"
export * from "./navTabs.vue?vue&type=script&lang=js&"
import style0 from "./navTabs.vue?vue&type=style&index=0&id=246b25ee&prod&lang=scss&scoped=true&"
import style1 from "./navTabs.vue?vue&type=style&index=1&id=246b25ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b25ee",
  null
  
)

export default component.exports